<template>
	<div class="home-release">
		<div class="home-release1">
			<template v-if="isPc">
				<img class="title" v-if="En" src="https://obs-gociif.ciif-expo.com/ciif/static/images/new/title-home-release-en.png" alt="">
				<img class="title" v-else src="https://obs-gociif.ciif-expo.com/ciif/static/images/new/title-home-release.png" alt="">
			</template>
			<template v-else>
				<img class="title" v-if="En" src="https://obs-gociif.ciif-expo.com/ciif/static/images/new/wap/title-home-release-en.png" alt="">
				<img class="title" v-else src="https://obs-gociif.ciif-expo.com/ciif/static/images/new/wap/title-home-release.png" alt="">
			</template>
		</div>
		<div class="home-release2">
			<ul>
				<li v-for="(item, index) in list" :key="index" :class="activeIndex === index ? 'active' : ''"
					@mouseenter="selcetChange(index)"  @click="openDetail(item)">
					<div class="img" v-if="!isPc" :style="{ backgroundImage: `url(${ (item['topCoverUrl' + En] || item['topCoverUrl'] || item['coverUrl' + En]) + '?x-image-process=image/resize,w_1200,limit_0' })` }">
						<img src="https://obs-gociif.ciif-expo.com/ciif/static/images/new/video.png" v-if="!!item.videoUrl&&shwoVideoBtn" class="playbtn"/>
					</div>
					{{ item['name' + En] }}
				</li>
			</ul>
			<div class="btns">
				<div class="btn" @click="moreFn">
					{{ $t('newbanner6') }}
					<img class="img1" src="https://obs-gociif.ciif-expo.com/ciif/static/images/new/right-black.png" alt="">
					<img class="img2" src="https://obs-gociif.ciif-expo.com/ciif/static/images/new/right-white.png" alt="">
				</div>
			</div>
		</div>
		<div class="home-release3">
			<!-- <div class="label" @click.stop="play(activeIndex)" v-if="list[activeIndex]"> -->
			<div class="label" @click.stop="openDetail(list[activeIndex])" v-if="list[activeIndex]">
				<!-- <video playsinline webkit-playsinline :src="list[activeIndex].videoUrl" :id="'videoPlay' + activeIndex" ref="videoPlay" v-if="list[activeIndex].videoUrl" :poster="list[activeIndex].coverUrl + '?x-image-process=image/resize,w_1200,limit_0'">
					您的浏览器不支持 video 标签。
				</video> -->
				<img :src="(list[activeIndex]['topCoverUrl' + En] || list[activeIndex]['topCoverUrl'] || list[activeIndex]['coverUrl' + En]) + '?x-image-process=image/resize,w_1200,limit_0'" class="fm" alt="">
				<img src="https://obs-gociif.ciif-expo.com/ciif/static/images/new/video.png" v-if="!!list[activeIndex].videoUrl&&shwoVideoBtn" class="playbtn"/>
			</div>
		</div>
	</div>
</template>

<script>
import protal from "@/api/protal";
export default {
	name: 'news_release',
	data() {
		return {
			activeIndex: 0,
			list: [],
			swiper: '',
			shwoVideoBtn: true
		}
	},
	computed: {
		slide3() {
			return index => {
				if (this.activeIndex === index) return false;
				if (this.activeIndex === (this.list.length - 2)) {
					return index === 0
				}
				if (this.activeIndex === (this.list.length - 1)) {
					return index === 1
				}
				return index === (this.activeIndex + 2)
			}
		},
	},
	watch: {	
		activeIndex(v) {
			const dom = document.getElementById('videoPlay' + v)
			this.shwoVideoBtn = true
			if (dom) {
				dom.pause()
			}
		}
	},
	created() {
		this.queryWebReleaseList()
	},
	methods: {
		moreFn() {
			this.$router.push('/news_publish?pageType=release')
		},
		play(index){
			const dom = document.getElementById('videoPlay' + index)
			if (dom.paused) {
				this.shwoVideoBtn = false
				dom.play()
			} else {
				this.shwoVideoBtn = true
				dom.pause()
			}
		},
		// 打开详情页
		openDetail(v) {
			this.$jsAPI('track', 'ciif_homePage_release', {
				contentID_var: v.uuid,
				contentName_var: v.name,
				contenReleaseType_var: v.tagList[0].name,
			})
			this.$store.commit('setPageName', {
				name:'发布详情',
				nameEn:'Release Details',
			})
			this.openMatch({ path: '/match_process', query: { pageType: 'release', uuid: v.uuid } },v)
		},
		// 官网查询发布列表
		queryWebReleaseList() {
			let that = this
			protal.queryWebReleaseList({
				"pageNum": 1,
				"pageSize": 10,
				"topSts": 0
			}).then(r => {
				this.list = r.data
				this.$nextTick(() => {
					that.swiper = new Swiper('.mySwiper3-wap', {
						loop: true,
						autoplay: 3000,
						speed: 600,
						onTransitionStart: function (swiper) {
							that.activeIndex = swiper.realIndex
						},
						autoplayDisableOnInteraction: false
					})
				})
			})
		},
		prev() {
			if (!this.isPc) {
				this.swiper.slidePrev()
			} else {
				this.activeIndex--
				if (this.activeIndex === -1) {
					this.activeIndex = this.list.length - 1
				}
			}
		},
		next() {
			if (!this.isPc) {
				this.swiper.slideNext()
			} else {
				this.activeIndex++
				if (this.activeIndex === this.list.length) {
					this.activeIndex = 0
				}
			}
		},
		selcetChange(index) {
			this.activeIndex = index
			this.swiper && this.swiper.slideTo && this.swiper.slideTo(index + 1)
		}
	}
}
</script>

<style lang="less" scoped>
@media screen and (min-width: 769px) {
	.home-release {
		padding-top: 158px;
		position: relative;
		border: 1px solid rgba(11, 36, 63, 0.2);
		padding-bottom: 120px;
		min-height: 1024px;

		.home-release1 {
			margin-bottom: 60px;
			
			.title {
				width: auto;
				height: 144px;
			}
		}

		.home-release2 {
			padding-left: 120px;
			
			ul {

				li {
					width: 730px;
					font-family: Inter, syn;
					font-weight: 500;
					font-size: 28px;
					color: #000000;
					line-height: 36px;
					text-align: left;
					font-style: normal;
					padding: 35px 20px;
					cursor: pointer;
					position: relative;

					&::after {
						content: "";
						position: absolute;
						left: 20px;
						right: 20px;
						bottom: 0;
						border-bottom: 1px solid rgba(11,36,63,0.2);
					}

					&.active {
						background: #F4501C;
						box-shadow: 0px 10px 40px 0px rgba(244,80,28,0.3);
						border-radius: 24px;
						color: #fff;
					}
				}
			}
			
			.btns {
				display: flex;
				padding: 52px 0 0 17px;

				.btn {
					height: 56px;
					border: 1px solid rgba(11, 36, 63, 0.6);
					border-radius: 12px;
					font-family: MiSans, MiSans;
					font-weight: 500;
					font-size: 16px;
					color: #0B243F;
					line-height: 16px;
					text-align: left;
					font-style: normal;
					padding: 0 28px 0 20px;
					display: flex;
					align-items: center;
					justify-content: center;
					margin-right: 16px;
					cursor: pointer;

					img {
						width: 24px;
						height: auto;
						margin-left: 12px;
						display: none;

						&.img1 {
							display: block;
						}

						&.img2 {
							display: none;
						}
					}

					&:hover {
						background-color: #F4501C;
						border-color: #F4501C;
						color: #fff;

						img {

							&.img1 {
								display: none;
							}

							&.img2 {
								display: block;
							}
						}
					}
				}
			}
		}

		.home-release3 {
			position: absolute;
			left: 970px;
			top: 322px;

			.label {
				position: relative;
				width: 810px;
				height: 456px;
				cursor: pointer;

				video {
					width: 100%;
					height: 100%;
					border-radius: 24px;
					background: #000;
				}

				.fm {
					width: 100%;
					height: 100%;
					border-radius: 24px;
				}

				.playbtn {
					position: absolute;
					left: 50%;
					top: 50%;
					transform: translate(-50%, -50%);
					width: 80px;
					height: auto;
				}
			}
		}
	}
}

@media screen and (max-width: 768px) {
	.home-release {
		padding-top: 1.2rem;
		position: relative;
		background: linear-gradient(to bottom, #D4D4DA 0%, #D4D4DA 70%, #F4F4F6 100%);
		padding-bottom: 1rem;
		border-bottom: 1px solid rgba(11, 36, 63, 0.2);

		&::before {
			content: "";
			position: absolute;
			left: 0;
			right: 0;
			top: 0;
			height: 2rem;
			background-image: url(https://obs-gociif.ciif-expo.com/ciif/static/images/new/chilun4.png);
			background-size: 1.44rem auto;
			background-repeat: no-repeat;
			background-position: 6.4rem 0.1rem;
		}

		.home-release1 {
			
			.title {
				width: auto;
				height: 1.44rem;
			}
		}

		.home-release2 {
			position: relative;
			z-index: 1;
			
			ul {

				li {
					width: 6.78rem;
					font-family: Inter, syn;
					font-weight: 500;
					font-size: .28rem;
					color: #000000;
					line-height: .4rem;
					text-align: left;
					font-style: normal;
					cursor: pointer;
					position: relative;
					margin: 0 auto .4rem;

					.img {
						width: 6.78rem;
						height: 4.52rem;
						border-radius: 0.28rem;
						position: relative;
						margin-bottom: .2rem;
						background-size: cover;
						background-position: center top;

						img {
							width: .8rem;
							height: auto;
							position: absolute;
							left: 50%;
							top: 50%;
							transform: translate(-50%, -50%);
						}
					}
				}
			}
			
			.btns {
				display: flex;
				padding: .12rem 0 0 0.36rem;

				.btn {
					height: .88rem;
					border: 1px solid rgba(11, 36, 63, 0.6);
					border-radius: .2rem;
					font-family: MiSans, MiSans;
					font-weight: 500;
					font-size: .24rem;
					color: #0B243F;
					line-height: .24rem;
					text-align: left;
					font-style: normal;
					padding: 0 .28rem;
					display: flex;
					align-items: center;
					justify-content: center;
					cursor: pointer;

					img {
						width: .36rem;
						height: auto;
						margin-left: .12rem;
						display: none;

						&.img1 {
							display: block;
						}

						&.img2 {
							display: none;
						}
					}

					&:hover {
						background-color: #F4501C;
						border-color: #F4501C;
						color: #fff;

						img {

							&.img1 {
								display: none;
							}

							&.img2 {
								display: block;
							}
						}
					}
				}
			}
		}

		.home-release3 {
			display: none;
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/pages/home/components/news_release.vue